import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment';

const noop = () => {};

@Component({
  selector: 'app-ep-date-form-field',
  templateUrl: './ep-date-form-field.component.html',
  styleUrls: ['./ep-date-form-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EpDateFormFieldComponent),
      multi: true,
    },
  ],
})
export class EpDateFormFieldComponent implements ControlValueAccessor {
  @Input() minDate: Date = new Date();
  @Input() maxDate: Date = new Date();
  @Input() isDisabled: boolean = false;
  @Input() errorMessage: string = '';
  @Input() placeholderMessage?: string = '';
  @Input() isValid: boolean = true;
  @Output() clickEvent = new EventEmitter();
  @Output() dateChange = new EventEmitter<Date | undefined>();
  private innerValue?: Date;

  private onChangeCallback(value: any): void {
    this.dateChange.emit(moment.isMoment(value) ? (value as moment.Moment).toDate() : undefined);
  }

  private onTouchedCallback: () => void = noop;

  constructor() {}

  public onDateClick(): void {
    this.clickEvent.emit();
  }

  get value(): Date {
    return this.innerValue as Date;
  }

  set value(v: Date) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  public writeValue(obj: Date): void {
    if (obj !== this.innerValue) {
      this.innerValue = obj;
    }
  }

  public registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
